import React from 'react';

export interface CategoryOption {
  id: string;
  label: string;
}

interface CategoryFilterProps {
  value: string;
  onChange: (value: string) => void;
  categories: CategoryOption[];
  label?: string;
  id?: string;
  className?: string;
  showAll?: boolean;
  disabled?: boolean;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  value,
  onChange,
  categories,
  label = "Size Category",
  id = "category",
  className = "",
  showAll = true,
  disabled = false
}) => {
  // Add "All" option if requested and not already present
  const allOptions = showAll && !categories.some(cat => cat.id === 'All') 
    ? [{ id: 'All', label: 'All Categories' }, ...categories]
    : categories;
  
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };
  
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium mb-2">{label}</label>
      <select
        id={id}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={`w-full bg-background-light border border-gray-700 rounded-md py-2 px-3 text-primary focus:border-accent focus:ring-1 focus:ring-accent ${disabled ? 'opacity-60' : ''}`}
      >
        {allOptions.map(category => (
          <option key={category.id} value={category.id}>
            {category.label}
          </option>
        ))}
      </select>
    </div>
  );
};

// Standard size categories used across the app
export const standardCategories: CategoryOption[] = [
  { id: 'All', label: 'All Categories' },
  { id: 'M', label: "Men's (M)" },
  { id: 'W', label: "Women's (W)" },
  { id: 'GS', label: 'Grade School (GS)' },
  { id: 'TD', label: 'Toddlers (TD)' }
];

// Helper function to map category ID to size type
export const categorySizeTypes: { [key: string]: string } = {
  "M": "M",
  "W": "W",
  "GS": "GS",
  "TD": "TD"
};

export default CategoryFilter; 